"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComposeConsoleErrorLogger = void 0;
const ComposeConsoleErrorLogger = () => {
    const initialize = () => { };
    const setUserProperty = (_propertyName, value) => {
        console.log(value);
    };
    const logError = (error, extraData) => {
        if (extraData) {
            console.log(`error: ${JSON.stringify(error)}, extraData: ${JSON.stringify(extraData)}`);
        }
        else {
            console.log(`error: ${JSON.stringify(error)}`);
        }
    };
    const logMessage = (message) => {
        console.log(message);
    };
    const addBreadcrumb = (category, message) => {
        console.log(`${category}: ${message || ""}`);
    };
    return {
        initialize,
        logError,
        logMessage,
        setUserProperty,
        addBreadcrumb,
    };
};
exports.ComposeConsoleErrorLogger = ComposeConsoleErrorLogger;
